<div class="list-data account-selection-div">
    <div class="list-caption relative" [ngClass]="{'no-margin-bottom': options.length === 0}" appClearInput
        (resetInput)="resetSearchText()">
        <input #globalSearch type="text" class="p-inputtext"
            placeholder="{{'vbeiSearchAccountByNameCodeCity' | translate}}" [(ngModel)]="searchText"
            (ngModelChange)="this.searchTextUpdate.next($event)" pInputText />
    </div>
    <p-listbox *ngIf="isInternalUser" [ngClass]="{'hidden': options?.length === 0}" appCustomVirtualScroller
        [scrollElementRef]="scrollElementRef" (scrollDown)="onScroll($event)" [options]="options"
        [(ngModel)]="selectedValue" (onClick)="onAccountSelection($event)">
        <ng-template let-data pTemplate="item">
            <div class="w-full flex-body">
                <span class="m-r-8" [innerHTML]="data | accountDisplay | highlight: searchText">
                </span>
                <span class="default-text green" *ngIf="data.isDefaultAccount">{{'DEFAULT' | translate}}</span>
            </div>
        </ng-template>
    </p-listbox>
    <p-listbox *ngIf="!isInternalUser" [ngClass]="{'hidden': options?.length === 0}" [options]="options"
        [(ngModel)]="selectedValue" (onClick)="onAccountSelection($event)">
        <ng-template let-data pTemplate="item">
            <div class="w-full flex-body">
                <span class="m-r-8" [innerHTML]="data | accountDisplay | highlight: searchText">
                </span>
                <span class="default-text green" *ngIf="data.isDefaultAccount">{{'DEFAULT' | translate}}</span>
            </div>
        </ng-template>
    </p-listbox>
    <label *ngIf="!isAccountsAvailable && !loading" class="no-data-msg">{{'vbeiNoAccountsAvailableError' | translate}}</label>
    <label *ngIf="isAccountsAvailable && loading" class="no-data-msg">{{'vbeLoading' | translate}}</label>
</div>